import { studentMapper } from "./studentsMapper"

export function classMapper(class_data) {
  if (class_data) {
    return {
      students: class_data.students
        ? class_data.students.map((student) => studentMapper(student))
        : undefined,
      id: class_data._id,
      name: class_data.name,
      grade: {
        id: class_data.grade._id,
        name: class_data.grade.name,
        order: class_data.grade.order,
      },
      assessmentsTime: class_data.exam_frequency,
      daysSelected: class_data.days,
      role: class_data.role_in_class?.name,
      status: class_data.status, // "OPEN" | "CLOSED"
      default_lang: class_data.default_lang,
    }
  } else {
    return null
  }
}

/**
 * Sorts classes by name using a mixed criteria:
 * - Elements starting with numbers are sorted first by numeric value (ascending)
 * - If numeric values are equal, sort alphabetically by full name
 * - Elements starting with letters are sorted alphabetically
 */
export function sortClassesByName(classes) {
  // Create a copy to avoid mutating the original array
  return [...classes].sort((a, b) => {
    const nameA = a.name.trim()
    const nameB = b.name.trim()

    // Check if names start with numbers
    const startsWithNumberA = /^\d/.test(nameA)
    const startsWithNumberB = /^\d/.test(nameB)

    // If both start with numbers, sort by numeric value (ascending), then alphabetically
    if (startsWithNumberA && startsWithNumberB) {
      const numA = parseInt(nameA.match(/^\d+/)?.[0] || "0")
      const numB = parseInt(nameB.match(/^\d+/)?.[0] || "0")
      if (numA !== numB) {
        return numA - numB // Ascending order by number
      }
      // If numbers are equal, sort alphabetically by the full name
      return nameA.localeCompare(nameB)
    }

    // If only A starts with number, A comes first
    if (startsWithNumberA) return -1

    // If only B starts with number, B comes first
    if (startsWithNumberB) return 1

    // If both start with letters, sort alphabetically
    return nameA.localeCompare(nameB)
  })
}

export function classesMapper(classes) {
  const mappedClasses = classes.classes
    .filter((c) => c.status === "OPEN")
    .map((c) => classMapper(c))

  return sortClassesByName(mappedClasses)
}

export function rolesMapper(data) {
  return data.map((role) => {
    return {
      id: role._id,
      name: role.name,
    }
  })
}
